import { z } from 'zod';

// ============================================================================
// PARAMS
// ============================================================================

export const patientIdParam = z.object({ id: z.string().min(1) });
export type PatientIdParam = z.infer<typeof patientIdParam>;

// ============================================================================
// QUERIES
// ============================================================================

export const getPatientsQuery = z.object({
  includeInactive: z.stringbool().default(false),
  includeCameras: z.stringbool().default(false),
  includeMatched: z.stringbool().default(false),
});
export type GetPatientsQuery = z.infer<typeof getPatientsQuery>;

export const getPatientQuery = z.object({
  includeEmergencyContacts: z.stringbool().default(false),
  includeCameras: z.stringbool().default(false),
});
export type GetPatientQuery = z.infer<typeof getPatientQuery>;

export const patientLogsQuery = z.object({
  startDate: z.iso.datetime({ offset: true }),
  endDate: z.iso.datetime({ offset: true }),
});
export type PatientLogsQuery = z.infer<typeof patientLogsQuery>;

// ============================================================================
// BODIES
// ============================================================================

export const createPatientBody = z.object({
  firstName: z.string().min(1),
  lastName: z.string().min(1),
  physicalAddress: z.string().min(1),
  timeZone: z.string().min(1),
  active: z.boolean(),
  careInstructions: z.string().optional(),
});
export type CreatePatientBody = z.infer<typeof createPatientBody>;

export const updatePatientBody = z.object({
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  physicalAddress: z.string().optional(),
  timeZone: z.string().optional(),
  active: z.boolean().optional(),
  inMonitoringHours: z.boolean().optional(),
  careInstructions: z.string().optional(),
});
export type UpdatePatientBody = z.infer<typeof updatePatientBody>;
